// src/features/preferences/services/preferencesApi.js
import { apiFetch } from '../../../lib/http';

/**
 * Preference enums for reference:
 * - dashboardLayout: "CARD" | "LIST"
 * - theme: "DARK" | "LIGHT"
 * - country: 2-letter country code (e.g., "US", "GB")
 * - defaultDifficulty: "BEGINNER" | "INTERMEDIATE" | "ADVANCED"
 */

export async function getPreferences(userId) {
  return apiFetch('/api/v1/users/preferences/get', {
    method: 'POST',
    body: { userId },
  });
}

export async function updatePreferences({ userId, dashboardLayout, theme, country, preferredDifficulty }) {
  return apiFetch('/api/v1/users/preferences/update', {
    method: 'POST',
    body: {
      userId,
      dashboardLayout,
      theme,
      country,
      preferredDifficulty,
    },
  });
}
